import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    showMenuAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessibility label for context menu button */
            showMenuAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationCell.showMenuAriaLabel?c=2c7hw2pvuvmk1", defaultMessage: "Show menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
